export default class createSubjectCtrl{

  constructor($scope, GeneralSettingsSrv, $mdDialog, $stateParams){
    $scope.specialization = {}
    $scope.searchNameRut = 'name'
    $scope.state = 'active'
    $scope.editOrCreated = ""
    $scope.textButton = ""
    $scope.teachers = {}
    $scope.periodArray = []
    $scope.selectedTeachers = []
    $scope.newSubject = {}
    $scope.editNewSubject = {}
    $scope.periodChecked = {}

    var edit = ($stateParams.subjectId)? true : false;

    if (edit) {
      $scope.textButton = "Guardar asignatura"
      $scope.mainLabel = 'Editar asignatura'
      $scope.editOrCreated = "modificado"
    }else{
      $scope.textButton = "Guardar nueva asignatura"
      $scope.mainLabel = 'Ingreso de nuevas asignaturas'
      $scope.editOrCreated = "creado"
      console.log($scope.editOrCreated)
    }

    $scope.hasError = function(input){
      if( input.$invalid && (input.$dirty || input.$touched ) )
        return 'has-error';
    }

    $scope.showErrorMessages = function(input)
    {
      return input.$dirty || input.$touched;
    }

    $scope.searchTeacher = (teacher) => {
      let matcher = new RegExp(teacher,'i')
      let arr = []
            
      $scope.teachers.forEach((teacher) => {
        if ( teacher["teacher_name"].match(matcher) || teacher["teacher_identification"].match(matcher)) {
          arr.push(teacher)
        }
      })
      return arr
    }

    $scope.isTeacherEmpty = function(){
      return $scope.selectedTeachers.length == 0;
    }

    $scope.isPeriodEmpty = function(){
      return $scope.periodArray.length == 0;
    }

    $scope.selectedPeriod = function( listPeriod, checked) {

      if( checked )
      {
        if( !$scope.periodArray.includes( listPeriod.periodicity_id ))
          $scope.periodArray.push( listPeriod.periodicity_id )
      }else{
        let index = $scope.periodArray.indexOf( listPeriod.periodicity_id );
        if( index != -1 )
          $scope.periodArray.splice( index , 1);
      }
    }

    function editNewSubject(){
      console.log("$scope.editNewSubject.subjectCode")
      console.log($scope.editNewSubject.subjectCode)
      $scope.periodArray = []
      $scope.nameSubject = $scope.editNewSubject.subjectName
      $scope.codigoSubject = $scope.editNewSubject.subjectCode
      for (var index in $scope.specialization){
        if ($scope.specialization[index].specialization_id == $scope.editNewSubject.subjectSpecializationId){
          $scope.specializationModel = $scope.specialization[index]
        }
      }
      $scope.hoursSubject = $scope.editNewSubject.subjectHours
      if ( $scope.editNewSubject.isActive == 1 ){
        $scope.state = "active"
      }else{
        if ( $scope.editNewSubject.isActive == 0 ){
          $scope.state = "inactive"
        }
      }
      var arrayPeriod = $scope.editNewSubject.periodsId.split(",")
      for (var indexarr = 0; indexarr < arrayPeriod.length; indexarr++){
        for (var index in $scope.period){
          if ($scope.period[index].periodicity_id == arrayPeriod[indexarr]){
            $scope.periodArray.push($scope.period[index].periodicity_id)
          }
        }

      }
      var periodSelected = {}
      var aux = 0
      for (var index = 0; index < arrayPeriod.length; index++){
        aux = arrayPeriod[index]
        periodSelected[aux] = true
      }
      $scope.periodChecked = periodSelected
      var arrayTeacher = $scope.editNewSubject.teachersId.split(",")
      for (var indexarr = 0; indexarr < arrayTeacher.length; indexarr++){
        for (var index in $scope.teachers){
          if ($scope.teachers[index].teacher_id == arrayTeacher[indexarr]){
            $scope.selectedTeachers.push($scope.teachers[index])
          }
        }
      }
    }

    $scope.addSubject = () => {
        createJson()
    }

    function createJson(){
      if ( $scope.state == "active" ){
        $scope.state = 1;
      }else{
        if ( $scope.state == "inactive" ){
          $scope.state = 0;
        }
      }
      var assignment = {
        subjectId :$stateParams.subjectId,
        subjectName: $scope.nameSubject,
        isActive: $scope.state,
        subjectCode: $scope.codigoSubject,
        subjectSpecializationId: $scope.specializationModel.specialization_id,
        subjectHours: $scope.hoursSubject
      }
      var arrayTeacher = []
      for (var index in $scope.selectedTeachers){
        var temp = {
          teacherId:$scope.selectedTeachers[index].teacher_id
        }
        arrayTeacher.push(temp)
      }
      var arrayPeriod = []
      for (var index in $scope.periodArray){
        var temp = {
          periodId:$scope.periodArray[index]
        }
        arrayPeriod.push(temp);
      }            
      assignment.teachers = arrayTeacher
      assignment.periods = arrayPeriod
      $scope.newSubject =  assignment
      if (edit){
        callServiceEditNewSubject($scope.newSubject)

      }else{
        callServiceAddNewSubject($scope.newSubject)
      }

    }

    function callServiceEditNewSubject(newSubject){
      GeneralSettingsSrv.updateSubject.update({subject: newSubject})
      .$promise.then(function(dataReturn) {
         if(dataReturn.status == true){
           showModalSubjectCreated();
         }else{
           console.log("Comunications problem with the server")
         }
      },function(data) {
        console.log(data)
      });
    }

    function callServiceAddNewSubject(newSubject){
      GeneralSettingsSrv.addNewSubject.save({subject: newSubject})
      .$promise.then(function(dataReturn) {
         if(dataReturn.status == true){
           showModalSubjectCreated();
         }else{
           console.log("Comunications problem with the server")
         }
      },function(data) {
        console.log(data)
      });
    }

    function showModalSubjectCreated(){
      let subjectName = $scope.nameSubject
      let actionName = $scope.editOrCreated
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function showModalSubjectCreated($scope, $mdDialog) {
          $scope.nameSubjectModal = subjectName
          $scope.actionName = actionName
          $scope.close = function() {
            $mdDialog.hide()
          }
        }],
        template: require('./subjectCreatedModal.html'),
        clickOutsideToClose:false
      })
    }

    $scope.addTeacher = (teacher) => {
      if (teacher){
        let idx = $scope.selectedTeachers.indexOf(teacher)
        if ( idx  === -1 ) {
          $scope.selectedTeachers.push(teacher)
          $scope.searchText = null;
        }
      }
    }

    $scope.removeTeacher = (teacher) => {
      let idx = $scope.selectedTeachers.indexOf(teacher)
      $scope.selectedTeachers.splice(idx, 1)
    }

    $scope.validateForm = function(form){
        return form.$invalid;
    }

    // List new subjects
    GeneralSettingsSrv.getInfoCreateNewSubject.getList()
    .$promise.then(function(dataReturn) {
         if(dataReturn.status == true){
           $scope.specialization = dataReturn.data.specialization;
           $scope.teachers = dataReturn.data.teachers;
           $scope.period = dataReturn.data.periodicities;
         }else{
           $scope.specialization = [];
           $scope.teachers = [];
           $scope.period = [];
         }
    },function(data) {
         console.log(data);
    })
    .then(function(){

      if ($stateParams.subjectId) {
        GeneralSettingsSrv.getSubject.get({subjectId: $stateParams.subjectId})
        .$promise.then(function(dataReturn) {
           if(dataReturn.status == true){
            console.log("dataReturn")
            console.log(dataReturn)
             $scope.editNewSubject = dataReturn.data[0]
             editNewSubject()
           }else{
             console.log("Comunications problem with the server")
           }
        },function(data) {
          console.log(data);
        });
      }

    })



	}
}

createSubjectCtrl.$inject = ['$scope','GeneralSettingsSrv','$mdDialog','$stateParams'];



// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/subjects/create/createSubjectCtrl.js